import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MagicLinkRequest from '@pages/customer-portal/auth';
import EmailSentConfirmation from '@pages/customer-portal/auth/email-confirmation';
import VerifyMagicLink from '@pages/customer-portal/auth/verify';
import CustomerPortalDashboard from '@pages/customer-portal';
import { clearStoredPortalSession, hasValidStoredPortalSession } from '@config/axiosPortal';
import { usePH } from '@hooks/use-ph';

const ProtectedPortalRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (!hasValidStoredPortalSession()) {
    clearStoredPortalSession();
    return <Navigate to="/login" replace />;
  }

  return children;
};

const PHBootstrap: React.FC = () => {
  usePH();
  return null;
};

const App: React.FC = () => {
  return (
    <>
      <PHBootstrap />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<MagicLinkRequest />} />
        <Route path="/login/email-sent" element={<EmailSentConfirmation />} />
        <Route path="/auth" element={<VerifyMagicLink />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedPortalRoute>
              <CustomerPortalDashboard />
            </ProtectedPortalRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default App;
